import { Link } from 'react-router-dom';
import LinkedinColor from '../icons/LinkedinColor';
import Snapchat from '@/assets/svg/Snapchat';

const iconLinkClass =
    'bg-primery-blue-50 rounded-full flex h-9 w-9 items-center justify-center shrink-0';

export default function SocialLinks() {
    return (
        <div className="flex items-center gap-3">
            <Link
                to="https://www.linkedin.com/company/mrn-ware/about/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Linkedin"
                className={iconLinkClass}
            >
                <LinkedinColor width="18" height="18" />
            </Link>
            <Link
                to="https://x.com/MRN_ware"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X"
                className={iconLinkClass}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M4.03608 4L9.82737 12.2733L4 19H5.31189L10.4142 13.1109L14.5364 19H19L12.8832 10.2614L18.3075 4H16.9957L12.2972 9.42369L8.50053 4H4.03695H4.03608ZM5.96474 5.03228H8.01484L17.0696 17.9677H15.0195L5.96474 5.03228Z"
                        fill="#145DA0"
                    />
                </svg>
            </Link>
            <Link
                to="https://www.facebook.com/profile.php?id=61580062269747"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className={iconLinkClass}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M14.25 8.25V10.5H16.5L16.125 13.5H14.25V22.5H11.25V13.5H9V10.5H11.25V8.0625C11.25 6.08203 12.8555 4.5 14.8125 4.5H16.5V7.5H15.1875C14.6719 7.5 14.25 7.91016 14.25 8.25Z"
                        fill="#145DA0"
                    />
                </svg>
            </Link>
            <Link
                to="https://www.instagram.com/mrnware/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className={iconLinkClass}
            >
                <svg width="18" height="18" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10 2.66211C12.6719 2.66211 12.9883 2.67383 14.0391 2.7207C15.0156 2.76367 15.543 2.92773 15.8945 3.06445C16.3594 3.24414 16.6953 3.46289 17.043 3.81055C17.3945 4.16211 17.6094 4.49414 17.7891 4.95898C17.9258 5.31055 18.0898 5.8418 18.1328 6.81445C18.1797 7.86914 18.1914 8.18555 18.1914 10.8535C18.1914 13.5254 18.1797 13.8418 18.1328 14.8926C18.0898 15.8691 17.9258 16.3965 17.7891 16.748C17.6094 17.2129 17.3906 17.5488 17.043 17.8965C16.6914 18.248 16.3594 18.4629 15.8945 18.6426C15.543 18.7793 15.0117 18.9434 14.0391 18.9863C12.9844 19.0332 12.668 19.0449 10 19.0449C7.32813 19.0449 7.01172 19.0332 5.96094 18.9863C4.98438 18.9434 4.45703 18.7793 4.10547 18.6426C3.64063 18.4629 3.30469 18.2441 2.95703 17.8965C2.60547 17.5449 2.39063 17.2129 2.21094 16.748C2.07422 16.3965 1.91016 15.8652 1.86719 14.8926C1.82031 13.8379 1.80859 13.5215 1.80859 10.8535C1.80859 8.18164 1.82031 7.86523 1.86719 6.81445C1.91016 5.83789 2.07422 5.31055 2.21094 4.95898C2.39063 4.49414 2.60938 4.1582 2.95703 3.81055C3.30859 3.45898 3.64063 3.24414 4.10547 3.06445C4.45703 2.92773 4.98828 2.76367 5.96094 2.7207C7.01172 2.67383 7.32813 2.66211 10 2.66211ZM10 0.861328C7.28516 0.861328 6.94531 0.873047 5.87891 0.919922C4.81641 0.966797 4.08594 1.13867 3.45313 1.38477C2.79297 1.64258 2.23438 1.98242 1.67969 2.54102C1.12109 3.0957 0.78125 3.6543 0.523438 4.31055C0.277344 4.94727 0.105469 5.67383 0.0585938 6.73633C0.0117188 7.80664 0 8.14648 0 10.8613C0 13.5762 0.0117188 13.916 0.0585938 14.9824C0.105469 16.0449 0.277344 16.7754 0.523438 17.4082C0.78125 18.0684 1.12109 18.627 1.67969 19.1816C2.23438 19.7363 2.79297 20.0801 3.44922 20.334C4.08594 20.5801 4.8125 20.752 5.875 20.7988C6.94141 20.8457 7.28125 20.8574 9.99609 20.8574C12.7109 20.8574 13.0508 20.8457 14.1172 20.7988C15.1797 20.752 15.9102 20.5801 16.543 20.334C17.1992 20.0801 17.7578 19.7363 18.3125 19.1816C18.8672 18.627 19.2109 18.0684 19.4648 17.4121C19.7109 16.7754 19.8828 16.0488 19.9297 14.9863C19.9766 13.9199 19.9883 13.5801 19.9883 10.8652C19.9883 8.15039 19.9766 7.81055 19.9297 6.74414C19.8828 5.68164 19.7109 4.95117 19.4648 4.31836C19.2188 3.6543 18.8789 3.0957 18.3203 2.54102C17.7656 1.98633 17.207 1.64258 16.5508 1.38867C15.9141 1.14258 15.1875 0.970703 14.125 0.923828C13.0547 0.873047 12.7148 0.861328 10 0.861328Z"
                        fill="#145DA0"
                    />
                    <path
                        d="M10 5.72461C7.16406 5.72461 4.86328 8.02539 4.86328 10.8613C4.86328 13.6973 7.16406 15.998 10 15.998C12.8359 15.998 15.1367 13.6973 15.1367 10.8613C15.1367 8.02539 12.8359 5.72461 10 5.72461ZM10 14.1934C8.16016 14.1934 6.66797 12.7012 6.66797 10.8613C6.66797 9.02149 8.16016 7.5293 10 7.5293C11.8398 7.5293 13.332 9.02149 13.332 10.8613C13.332 12.7012 11.8398 14.1934 10 14.1934Z"
                        fill="#145DA0"
                    />
                    <path
                        d="M16.5391 5.52145C16.5391 6.18551 16 6.72067 15.3398 6.72067C14.6758 6.72067 14.1406 6.18161 14.1406 5.52145C14.1406 4.85739 14.6797 4.32223 15.3398 4.32223C16 4.32223 16.5391 4.86129 16.5391 5.52145Z"
                        fill="#145DA0"
                    />
                </svg>
            </Link>
            <Link
                to="https://www.snapchat.com/add/mrnware?share_id=gmKn19S2Wvc&locale=en-GB"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Snapchat"
                className={iconLinkClass}
            >
                <Snapchat fill="#145DA0" width="18" height="18" />
            </Link>
        </div>
    );
}
